export const isAccessTokenExpired = accessToken => {
    if (accessToken && accessToken.exp) {
        return 1000 * accessToken.exp - new Date().getTime() < 20000;
    }
    return true;
};

export const isRefreshTokenExpired = refreshToken => {
    if (refreshToken && refreshToken.exp) {
        return 1000 * refreshToken.exp - new Date().getTime() < 20000;
    }
    return true;
};

export const isAuthenticated = refreshToken => {
    return !isRefreshTokenExpired(refreshToken);
};
